/* Daily Cart V4.9 (Oct 24): (1) Add to cart button in the sticky header, (2) product photo arrows, swipe, tap / pinch zoom. The thumbnail row keeps working (dc.js). */
/* (1) header Add to cart: same button logic as the old bottom bar (it clicks that bar's hidden button), label follows it */
(function () {
  try {
    var go = document.querySelector('[data-dc-sticky-go]');
    var acts = document.querySelector('.dc-header .dc-actions');
    if (!go || !acts) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dc-btn dc-hcta';
    var cart = acts.querySelector('[data-dc-cart-open]');
    acts.insertBefore(b, cart || null);
    function label() {
      var t = (go.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
      b.innerHTML = '<span class="dc-hcta__f"></span><span class="dc-hcta__s"></span>';
      b.firstChild.textContent = t;
      b.lastChild.textContent = t === 'Add your photo' ? 'Add photo' : t;
      b.setAttribute('aria-label', t);
    }
    label();
    if ('MutationObserver' in window) new MutationObserver(label).observe(go, { childList: true, characterData: true, subtree: true });
    b.addEventListener('click', function () {
      go.click();
      try { if (typeof window.clarity === 'function') window.clarity('event', 'header_cta'); } catch (e) {}
    });
  } catch (err) {}
})();

/* (2) product photos */
(function () {
  try {
    var main = document.querySelector('.dc-gallery__main');
    if (!main) return;
    var slides = [].slice.call(main.querySelectorAll('[data-slide]'));
    var tr = main.parentNode.querySelector('.dc-gallery__thumbs');
    var thumbs = tr ? [].slice.call(tr.querySelectorAll('[data-thumb]')) : [];
    var nav = slides.length > 1 && thumbs.length === slides.length;
    var s = 1, tx = 0, ty = 0, pts = {}, g = null, last = -1, own = false, zOnce = false, lastZ = null;
    function ev(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }

    var A = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
    var chevL = A + '<path d="M15 5l-7 7 7 7"/></svg>';
    var chevR = A + '<path d="M9 5l7 7-7 7"/></svg>';
    var zin = A + '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/></svg>';
    var zout = A + '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M8 11h6"/></svg>';
    function mk(cls, label, html) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dc-gal-ui ' + cls; b.setAttribute('aria-label', label); b.innerHTML = html;
      main.appendChild(b); return b;
    }

    function idx() { for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i; return 0; }
    function img() { var a = main.querySelector('.dc-gallery__slide.is-active'); return a && !a.querySelector('video') ? a.querySelector('img') : null; }
    function clampT() {
      var r = main.getBoundingClientRect(), mx = (s - 1) * r.width / 2, my = (s - 1) * r.height / 2;
      tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
    }
    function rel(e) { var r = main.getBoundingClientRect(); return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 }; }

    var cnt = null, zbtn = mk('dc-gal-zoom', 'Zoom in', zin), prev = null, next = null;
    if (nav) {
      prev = mk('dc-gal-arrow dc-gal-arrow--prev', 'Previous photo', chevL);
      next = mk('dc-gal-arrow dc-gal-arrow--next', 'Next photo', chevR);
      cnt = document.createElement('span'); cnt.className = 'dc-gal-ui dc-gal-count'; cnt.setAttribute('aria-hidden', 'true');
      main.appendChild(cnt);
    }

    function apply(smooth) {
      var im = img();
      if (im) {
        im.style.transition = smooth ? 'transform .22s ease' : 'none';
        im.style.transform = s > 1 ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')' : '';
      }
      var z = s > 1;
      main.classList.toggle('is-zoomed', z);
      if (z !== lastZ) { lastZ = z; zbtn.innerHTML = z ? zout : zin; zbtn.setAttribute('aria-label', z ? 'Zoom out' : 'Zoom in'); }
    }
    function reset() {
      s = 1; tx = 0; ty = 0;
      slides.forEach(function (sl) { var m = sl.querySelector('img'); if (m && m.style.transform) { m.style.transition = 'none'; m.style.transform = ''; } });
      apply(false);
    }
    function zoomAt(ns, px, py) {
      var ux = (px - tx) / s, uy = (py - ty) / s;
      s = ns; tx = px - s * ux; ty = py - s * uy; clampT();
      if (!zOnce) { zOnce = true; ev('gallery_zoom'); }
    }
    function toggleZoom(px, py) {
      if (!img()) return;
      if (s > 1) { s = 1; tx = 0; ty = 0; } else { zoomAt(2.5, px, py); }
      apply(true);
    }
    function go(d) {
      if (!nav) return;
      var n = (idx() + d + slides.length) % slides.length;
      own = true; thumbs[n].click(); own = false;
    }

    /* keep counter, zoom and the thumbnail row in step with whichever slide is showing (thumb tap, arrow, swipe, variant change) */
    function sync() {
      var i = idx();
      if (i === last) return;
      var first = last === -1;
      last = i;
      reset();
      if (cnt) cnt.textContent = (i + 1) + ' / ' + slides.length;
      main.classList.toggle('dc-can-zoom', !!img());
      if (!first && tr && thumbs[i]) {
        try {
          var a = tr.getBoundingClientRect(), b = thumbs[i].getBoundingClientRect();
          tr.scrollTo({ left: tr.scrollLeft + (b.left - a.left) - (a.width - b.width) / 2, behavior: 'smooth' });
        } catch (e) {}
      }
    }
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      slides.forEach(function (sl) { mo.observe(sl, { attributes: true, attributeFilter: ['class'] }); });
    }
    sync();

    if (nav) {
      prev.addEventListener('click', function () { go(-1); ev('gallery_arrow'); });
      next.addEventListener('click', function () { go(1); ev('gallery_arrow'); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { if (!own) ev('gallery_thumb'); }); });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(-1); } else if (e.key === 'ArrowRight') { go(1); }
      });
    }
    zbtn.addEventListener('click', function () { toggleZoom(0, 0); });

    /* touch / mouse: swipe between photos, pinch to zoom, tap to zoom, drag to pan while zoomed */
    main.addEventListener('dragstart', function (e) { e.preventDefault(); });
    main.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    main.addEventListener('touchmove', function (e) { if (e.touches.length > 1 || s > 1) e.preventDefault(); }, { passive: false });
    main.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('.dc-gal-ui')) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pts[e.pointerId] = rel(e);
      var ids = Object.keys(pts);
      if (ids.length === 1) {
        var p = pts[e.pointerId];
        g = { m: 1, x0: p.x, y0: p.y, tx0: tx, ty0: ty, s0: s, t0: Date.now(), moved: false };
      } else if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        g = { m: 2, d0: Math.hypot(a.x - b.x, a.y - b.y) || 1, mx0: (a.x + b.x) / 2, my0: (a.y + b.y) / 2, tx0: tx, ty0: ty, s0: s };
      }
    });
    main.addEventListener('pointermove', function (e) {
      if (!g || !pts[e.pointerId]) return;
      var p = rel(e); pts[e.pointerId] = p;
      if (g.m === 2) {
        var ids = Object.keys(pts);
        if (ids.length < 2 || !img()) return;
        var a = pts[ids[0]], b = pts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        var ux = (g.mx0 - g.tx0) / g.s0, uy = (g.my0 - g.ty0) / g.s0;
        s = Math.max(1, Math.min(4, g.s0 * d / g.d0));
        tx = mx - s * ux; ty = my - s * uy; clampT(); apply(false);
        if (!zOnce && s > 1.1) { zOnce = true; ev('gallery_zoom'); }
      } else {
        var dx = p.x - g.x0, dy = p.y - g.y0;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) g.moved = true;
        if (s > 1 && g.moved) { tx = g.tx0 + dx; ty = g.ty0 + dy; clampT(); apply(false); }
      }
    });
    function end(e, cancel) {
      if (!pts[e.pointerId]) return;
      var was = g, p = cancel ? pts[e.pointerId] : rel(e);
      delete pts[e.pointerId];
      var left = Object.keys(pts);
      if (was && was.m === 2) {
        if (s < 1.05) { s = 1; tx = 0; ty = 0; apply(true); }
        if (left.length === 1) {
          var q = pts[left[0]];
          g = { m: 1, x0: q.x, y0: q.y, tx0: tx, ty0: ty, s0: s, t0: Date.now(), moved: true };
        } else { g = null; }
        return;
      }
      g = null;
      if (cancel || !was) return;
      var dx = p.x - was.x0, dy = p.y - was.y0;
      if (!was.moved && Date.now() - was.t0 < 500) {
        toggleZoom(p.x, p.y);
      } else if (was.s0 === 1 && s === 1 && nav && Math.abs(dx) > 40 && Math.abs(dx) > 1.4 * Math.abs(dy)) {
        go(dx < 0 ? 1 : -1); ev('gallery_swipe');
      }
    }
    main.addEventListener('pointerup', function (e) { end(e, false); });
    main.addEventListener('pointercancel', function (e) { end(e, true); });
    main.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') end(e, true); });
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; reset(); } });
  } catch (err) {}
})();

/* (3) trust line under Add to cart (v4.11.2): swap the padlock emoji for a line icon that matches the icons below it */
(function () {
  try {
    var t = document.querySelector('.dc-trustline');
    if (!t || t.querySelector('svg')) return;
    var n = t.firstChild;
    if (!n || n.nodeType !== 3 || n.nodeValue.indexOf('🔒') < 0) return;
    n.nodeValue = n.nodeValue.replace('🔒', '').replace(/^ +/, '');
    t.insertAdjacentHTML('afterbegin', '<svg class="dc-icon dc-trust-ic" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>');
  } catch (err) {}
})();
